import React from 'react';
import './App.css';
import Bangladesh from './Components/Home/Bangladesh';
import Top from './Components/Home/Top';
import World from './Components/Home/World';

function App() {
  return (
    <div>
      <Top />
      <World />
      <Bangladesh />

    </div>
  );
}

export default App;
